import { DataClassName } from '@/Data/const'

export const getDeleteModalTitle: (dataClassName: string) => string = (
  dataClassName,
) => {
  switch (dataClassName) {
    case DataClassName.ACTIVITY:
      return 'pages.activity.delete.modal.title'
    case DataClassName.COMPANY:
      return 'pages.company.delete.modal.title'
    case DataClassName.DOCUMENT:
      return 'pages.document.delete.modal.title'
    case DataClassName.GLOBAL_RESULT:
      return ''
    case DataClassName.LEAD:
      return 'pages.lead.delete.modal.title'
    case DataClassName.LIST:
      return 'pages.list.delete.modal.title'
    case DataClassName.OPPORTUNITY:
      return 'pages.opportunity.delete.modal.title'
    case DataClassName.ORDER:
      return 'pages.order.delete.modal.title'
    case DataClassName.PERSON:
      return 'pages.person.delete.modal.title'
    case DataClassName.QUOTE:
      return 'pages.quote.delete.modal.title'
    case DataClassName.TICKET:
      return 'pages.ticket.delete.modal.title'
    default:
      console.warn(`No delete modal title found for ${dataClassName}`)
      return ''
  }
}
